/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class MultipleChoice extends BaseField {

    constructor (element: string | JQuery) {
        super(element);

        let self = this;

        this.element.on('click', '.remove-item', function (el) {
            if (self.element.find('tbody tr').length == 1) {
                alert('You cannot remove the last item.');
                return;
            }

            let tr = $(this).closest('tr');
            let itemText = tr.find('textarea').val();

            if (confirm('Are you sure you want to remove the below item?\n\n' + itemText)) {
                tr.remove();
            }
        });

        this.element.find('.add-item').on('click', function() {
            let tbody = self.element.find('tbody');
            let lastTr = tbody.find('tr:last-child');
            let newTr = lastTr.clone();
            newTr.find('textarea').val('');
            tbody.append(newTr);
        });
    }

    public getValue() {
        let value = [];

        this.element.find('textarea').each(function (i, el: HTMLTextAreaElement) {
            value.push(el.value);
        });

        return JSON.stringify(value);
    }

}

}
